import { ProfileCollectorDisplayState } from './display.types';

export const getDefaultDisplay = (): ProfileCollectorDisplayState => ({
  isFiltersDialogOpen: false,
});

export const displayInitialState: ProfileCollectorDisplayState = getDefaultDisplay();
